import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EChartsOption } from 'echarts';
import { NgxEchartsModule } from 'ngx-echarts';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-pie-chart',
  standalone: true,
  imports: [NgxEchartsModule],
  template: `
 <div class="flex w-full h-full">
      <div echarts 
           [options]="pieChartOptions" 
           [style.width]="'100%'"
           [style.height]="height + 'px'"
           class="w-full h-full">
      </div>
    </div>
  `,
  styles: ``
})
export class PieChartComponent {
  @Input() data$: Observable<any[]> = of([]);
  @Input() height: number = 200;
  @Input() chartlabel: boolean = true;
  @Input() xAxisLabel: boolean = true;
  @Input() yAxisLabel: boolean = true;

  pieChartOptions: EChartsOption = {};

  ngOnChanges(changes: SimpleChanges) {
    this.updateChartOptions();
  }

  updateChartOptions() {
    this.pieChartOptions = {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        show: this.chartlabel,
        orient: 'vertical',
        right: 10,
        top: 0,
        data: ['Known', 'Unknown']
      },
      series: [
        {
          name: 'Words',
          type: 'pie',
          center: ['35%', '50%'], 
          radius: ['50%', '95%'],
          label: {
            show: true,
            position: 'center',
            formatter: '900\nWords',
            fontSize: 24,
            fontWeight: 'bold',
            color: '#333',
          },
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 5,
            borderColor: '#fff',
            borderWidth: 3
          },
          emphasis: {
            label: {
              show: false,
              fontSize: '18',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true,
            length: 15,
            length2: 15
          },
          data: [
            { value: 800, name: 'Known', itemStyle: { color: '#2C4F94' } },
            { value: 200, name: 'Unknown', itemStyle: { color: '#E74C5E' } }
          ]
        }
      ]
    };
  }
}
